/**
 * Someone as the place pages draw them (a room's faces, an event's top three,
 * a season's members): one shape and one rule for their name, everywhere.
 */

/** Someone, as a face with a name. */
export interface Face {
  id: string;
  name: string;
  photoURL: string;
}

/** The user fields every face is read from. */
export interface FaceSource {
  id: string;
  public: { displayName: string; username: string; photoURL: string };
}

/** A user as a face: their display name, or their username when that is blank. */
export function faceOf(user: FaceSource): Face {
  return { id: user.id, name: user.public.displayName || user.public.username, photoURL: user.public.photoURL };
}
